import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '../styles/tss-react';

export const useStyles = makeStyles({
  name: 'SubmitErrorMessage',
})(() => ({
  errorText: {
    fontStyle: 'italic',
    marginTop: pxToRem(16),
    textAlign: 'center',
    '&& a': {
      color: 'inherit',
      textDecoration: 'underline',
      '&:hover, &:active, &:visited': {
        color: 'inherit',
      },
    },
  },
}));
